// extracted by mini-css-extract-plugin
export default {"input":"List_input__0a19b","generateButton":"List_generateButton__0n6MG","printButton":"List_printButton__SShtQ","qrContainer":"List_qrContainer__lomrp"};